<template>
  <UiModalContainer
    v-if="true"
    :modal-show="true"
    :modal-width="100"
    parent-modal-class="container mx-auto"
    modal-classes="width-full"
    @handleClick="handleClick"
  >
    <template v-slot:header>
      <span v-i18n="landingPage" class="sm:text-2.5xl text-lg font-poppins font-medium">
        {{ content.heading }}
      </span>
    </template>
    <template v-slot>
      <div
        class="px-8 sm:px-10 md:px-12 lg:px-16 xl:px-17.5 showModal-body pt-8 pb-8 sm:pt-15 sm:pb-15 lg:pb-17.5"
      >
        <Paragraph
          v-if="content.description"
          :text="content.description"
          child-class="xl:text-base lg:ltr:text-base pb-2.5 xl:pb-5"
        />
        <!--First Portal -->
        <div
          v-for="(portalContent, index) in content.firstPortal"
          :key="index"
          class="pb-12.25 md:pb-15 lg:pb-25"
        >
          <Portal
            container-class="mx-0 px-0 "
            :image="portalContent.firstPortalImage"
            :parent-class="
              index === 1
                ? 'sm:flex-row-reverse flex-col-reverse gap-5 md:gap-8 lg:gap-12 xl:gap-15 items-center '
                : 'sm:flex-row flex-col-reverse gap-5 md:gap-8 lg:gap-12 xl:gap-15 items-center '
            "
            border-class="p-5 rounded-19 border-color h-fit-content"
            image-class="rounded-19 "
          >
            <div class="flex flex-col flex-wrap gap-2.5 xl:gap-5">
              <DemoHeading
                :text="portalContent.firstPortalHeading"
                child-class="sm:ltr:text-2xl md:text-3xl xl:ltr:text-4.5xl xl:ltr:leading-60"
              />
              <Paragraph
                :text="portalContent.firstPortalHeadingDes"
                child-class="xl:text-base lg:ltr:text-base"
              />
            </div>
          </Portal>
        </div>
        <!-- first portal detail -->
        <div
          v-for="(detail, index) in content.firstPortalDetail"
          :key="index"
          class="flex flex-col flex-wrap gap-2.5 xl:gap-5 pb-2.5 xl:pb-5"
        >
          <DemoHeading
            v-if="detail.firstPortalHeading"
            :text="detail.firstPortalHeading"
            child-class="sm:ltr:text-2xl md:text-3xl xl:ltr:text-4.5xl xl:ltr:leading-60"
          />
          <Paragraph
            :text="detail.firstPortalHeadingDes"
            child-class="xl:text-base lg:ltr:text-base"
          />
        </div>

        <!--Second Portal -->
        <div
          v-if="content.secondPortalImage"
          class="bg-white opacity-100 pb-12.25 md:pb-15 lg:pb-25"
          :class="content.secondPortalstyle"
        >
          <Portal
            container-class="mx-0 px-0 "
            :image="content.secondPortalImage"
            parent-class="flex-col-reverse sm:flex-row gap-5 md:gap-8 lg:gap-12 xl:gap-15 items-center"
            child-class="sm:ltr:mt-0"
            border-class="p-5 rounded-19 border-color h-fit-content"
            image-class="img-flip rounded-19"
          >
            <div
              v-for="(portalContent, index) in content.secondPortal"
              :key="index"
              class="flex flex-col flex-wrap gap-2.5 xl:gap-5"
            >
              <DemoHeading
                :text="portalContent.secondPortalHeading"
                child-class="sm:ltr:text-2xl md:text-3xl xl:ltr:text-4.5xl xl:ltr:leading-60"
              />
              <Paragraph
                :text="portalContent.secondPortalHeadingDes"
                child-class="xl:text-base lg:ltr:text-base"
              />
            </div>
          </Portal>
        </div>
        <Terms
          v-if="content.secondPortalHeadingPoints"
          child-class="text-rich-black font-medium -mt-12 md:-mt-16 lg:-mt-24 xl:-mt-28"
          :use-term="content.secondPortalHeadingPoints"
        />
        <Paragraph
          v-if="content.secondPortalHeadingDesMore"
          :text="content.secondPortalHeadingDesMore"
          class="mt-2.5 xl:mt-5"
          child-class="xl:text-base lg:ltr:text-base"
        />
        <!-- without image section -->
        <div>
          <div
            v-for="(detail, index) in content.secondPortalDetail"
            :key="index"
            class="flex flex-col flex-wrap gap-2.5 xl:gap-5 pb-2.5 xl:pb-5"
          >
            <DemoHeading
              :text="detail.secondPortalHeading"
              child-class="sm:ltr:text-2xl md:text-3xl xl:ltr:text-4.5xl xl:ltr:leading-60"
            />
            <Paragraph
              :text="detail.secondPortalHeadingDes"
              child-class="xl:text-base lg:ltr:text-base"
            />
          </div>
          <Terms v-if="content.PortalParagraphPoints" :use-term="content.PortalParagraphPoints" />
          <Paragraph
            v-if="content.Note"
            :text="content.Note"
            child-class="xl:text-base lg:ltr:text-base text-text-primary-black font-medium"
          />
        </div>
        <!-- benefits -->
        <div :class="content?.benefits?.benefitsStyle ? '' : 'pt-12.25 md:pt-15 lg:pt-20'">
          <div
            v-i18n="landingPage"
            class="pb-2.5 sm:pb-5 lg:h-auto md:leading-46 md:rtl:h-24.25 text-text-primary-black text-3xl leading-9.5 font-bold rtl:h-21 sm:ltr:text-2xl md:text-3xl xl:ltr:text-4.5xl xl:ltr:leading-60"
          >
            {{ content?.benefits?.benefitsMainHeading }}
          </div>
          <div
            v-for="(benefit, index) in content?.benefits?.benefitsPoints"
            :key="index"
            class="flex flex-col flex-wrap gap-2.5 pb-2.5 xl:pb-5"
          >
            <div class="text-lg leading-34 font-bold">
              {{ index + 1 }} {{ $t(`landingPage.${benefit.benefitsHeading}`) }}
            </div>

            <Paragraph :text="benefit.benefitsDes" child-class="xl:text-base lg:ltr:text-base" />
          </div>
        </div>
        <!-- use term section -->
        <div v-if="content.useTerms">
          <UseTermSection :use-terms="content.useTerms" />
        </div>
      </div>
    </template>
  </UiModalContainer>
</template>

<script>
import UseTermSection from '@src/components/features-page/UseTermSection.vue'
import Terms from '@src/components/misc/Terms.vue'

import Portal from '@components/home-page/PortalSection.vue'
import UiModalContainer from '@src/components/UiElements/UiModalContainer.vue'
import DemoHeading from '@components/home-page/DemoSectionHeading.vue'
import Paragraph from '@components/home-page/DemoSectionParagarph.vue'
export default {
  components: {
    UiModalContainer,
    Portal,
    DemoHeading,
    Paragraph,
    UseTermSection,
    Terms,
  },
  props: {
    showDemoModal: { type: Boolean, default: false },
    content: { type: String, default: '' },
  },
  data() {
    return {
      sectionFirstDec: ['Campus Attendance', 'Section Attendance', 'Lecture Attendance'],
      showModal: false,
      landingPage: 'landingPage',
    }
  },
  watch: {
    showDemoModal: {
      immediate: true,
      handler(value) {
        this.showModal = value
      },
    },
  },
  methods: {
    handleClick(value) {
      if (value === 'close') {
        this.$emit('closeShowModal')
        if (this.$route.name === 'Features-modal') {
          this.$router.push({
            name: 'features',
          })
        } else {
          this.$router.push({
            name: 'home',
          })
        }
      }
    },
  },
}
</script>

<style scoped>
.bg-how-it-work-btn-1 {
  background: transparent linear-gradient(213deg, #ffc870 0%, #f7a92b 100%) 0% 0%;
  box-shadow: 1px 1px 12px #ffa7193b;
}
.bg-how-it-work-btn-2 {
  background: transparent linear-gradient(214deg, #8dbfff 0%, #4e8ddd 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #196dff3b;
}
.bg-how-it-work-btn-3 {
  background: transparent linear-gradient(207deg, #c3b6fb 0%, #9983fc 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #8419ff3b;
}
</style>
